export default __webpack_public_path__ + "locales/de/Files.json?hash=b02e6a35b286088f6048fc32fbb85a28";